let webPushIntervalId = null
const twoMinutes = 2 * 60 * 1000

export default async (ctx, inject) => {
  const webpush = {
    register: () => registerWebPush(ctx),
  }

  inject('webpush', webpush)
  webPushIntervalId = setInterval(() => registerWebPush(ctx), twoMinutes - 500)
}

async function registerWebPush(ctx) {
  if (!ctx.app.store.state.auth.user) return

  if (
    Date.now() -
      ctx.app.store.state.notification.webPushLastSubscriptionRequest <
    twoMinutes
  )
    return

  if (!('serviceWorker' in navigator && 'PushManager' in window)) {
    clearInterval(webPushIntervalId)
    return console.warn('Service workers are not supported')
  }

  try {
    const permission = await Notification.requestPermission()
    if (permission !== 'granted') {
      console.warn('Notification permission was denied')
      return
    }

    const registration = await getWebPushWorker()
    const subscription = await getWebPushSubscrition(
      registration,
      urlBase64ToUint8Array(ctx.env.publicVapidKey)
    )

    if (navigator.onLine) {
      await ctx.$axios.post('/v3/app/notification/web-push/register', {
        subscription,
      })

      ctx.app.store.commit('notification/setWebPushLastSubscriptionRequest')
    }
  } catch (error) {
    console.error('Error registering web push service worker', error)
  }
}

async function getWebPushWorker() {
  const worker = await navigator.serviceWorker.getRegistration(
    '/webpush-worker.js'
  )
  if (worker) return worker
  return await navigator.serviceWorker.register('/webpush-worker.js')
}

async function getWebPushSubscrition(registration, vapidKey) {
  const subscription = await registration.pushManager.getSubscription()
  if (subscription) return subscription
  return await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: vapidKey,
  })
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')

  const rawData = atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}
